module.exports = __webpack_public_path__ + "static/carrefour-c21dcebd82f07aaedc4febbe79250739.jpg";